// src/pages/AuthCallback.jsx
import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { login } = useAuth();

    useEffect(() => {
        const token = searchParams.get('token');
        if (token) {
            console.log("Received token from callback:", token);
            login(token); // Use the login function from context
            navigate('/', { replace: true }); // Redirect to home after login
        } else {
            console.error("No token found in callback URL");
            // Handle error - maybe redirect to a login failed page or home
            navigate('/', { replace: true });
        }
    }, [searchParams, login, navigate]);

    return (
        <div className="flex justify-center items-center h-screen bg-dark-700">
            <div className="text-center">
                <i className="fas fa-spinner fa-spin text-4xl text-accent-purple mb-4"></i>
                <p className="text-gray-300">Authenticating...</p>
            </div>
        </div>
    );
};

export default AuthCallback;